"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Constants = require("../00_environment/Constants");

var _Colors = require("../00_environment/Colors");

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _HighligthedText = _interopRequireDefault(require("../01_atoms/HighligthedText"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _PassengerDetails = _interopRequireDefault(require("./PassengerDetails"));

var _TicketDetails = _interopRequireDefault(require("./TicketDetails"));

var _TripPriceDetails = _interopRequireDefault(require("./TripPriceDetails"));

var _TripSeatDetails = _interopRequireDefault(require("./TripSeatDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TicketWidget = function TicketWidget(_ref) {
  var ticket = _ref.ticket,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('TicketDetailsPageUI');
  var _ticket$statusDetails = ticket.statusDetails,
      _ticket$statusDetails2 = _ticket$statusDetails.booked,
      booked = _ticket$statusDetails2 === void 0 ? true : _ticket$statusDetails2,
      _ticket$statusDetails3 = _ticket$statusDetails.cancelled,
      cancelled = _ticket$statusDetails3 === void 0 ? false : _ticket$statusDetails3;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !booked && !cancelled && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: -5,
      marginTop: -2,
      marginBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    warning: true,
    icon: true,
    style: {
      paddingTop: 30,
      paddingBottom: 30
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "wait",
    style: {
      fontSize: '32px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Content, {
    style: {
      fontSize: '0.9rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Header, {
    style: {
      fontSize: '1.1rem'
    }
  }, t('Order in process')), t('We are contacting the company to book your trip.'), t("You'll receive an email once your trip is confirmed.")))), cancelled && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: -5,
      marginTop: -2,
      marginBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    negative: true,
    icon: true,
    style: {
      paddingTop: 30,
      paddingBottom: 30
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "cancel",
    style: {
      fontSize: '32px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Content, {
    style: {
      fontSize: '0.9rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Header, {
    style: {
      fontSize: '1.1rem'
    }
  }, t('This order has been cancelled')), t('Details on this page are only informative.')))), /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
    title: t('Your trip'),
    ticketDetails: ticket.ticketDetails,
    nPassengers: _checkTypes["default"].nonEmptyArray(ticket.ticketDetails.passengers) ? ticket.ticketDetails.passengers.length : 1,
    locale: translationManager.getCurrentLanguage()
  }), /*#__PURE__*/_react["default"].createElement(_PassengerDetails["default"], {
    title: t('Passengers'),
    translatorForNamespace: translatorForNamespace,
    passengers: ticket.ticketDetails.passengers
  }), /*#__PURE__*/_react["default"].createElement(_TripSeatDetails["default"], {
    selectedSeats: (ticket.ticketDetails.passengers || []).map(function (p) {
      return p.seat;
    }),
    numberOfPassengers: (ticket.ticketDetails.passengers || []).length,
    translator: t
  }), /*#__PURE__*/_react["default"].createElement(_TripPriceDetails["default"], {
    trip: ticket.ticketDetails,
    numberOfPassengers: ticket.ticketDetails.passengers.length,
    isOneWayTrip: !ticket.ticketDetails.twoWaysTrip,
    translatorForNamespace: translatorForNamespace
  }), /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, t('Tickets are nominative.'), /*#__PURE__*/_react["default"].createElement("br", null), t("You'll need to present your"), ' ', /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, t('cedula or passport')), ' ', t('along with your ticket before boarding.')), /*#__PURE__*/_react["default"].createElement(_Element["default"], null, t("You'll receive your tickets"), ' ', /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, "".concat(t('by e-mail'), ".")), /*#__PURE__*/_react["default"].createElement("br", null), t('You can present your tickets either on the {appName} app or printed on paper.', {
    appName: _Constants.appName
  }))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, booked && !cancelled && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: "/tickets/".concat(ticket.id, "/boarding-pass/"),
    fluid: true,
    primary: true
  }, t('Show ticket')), !booked && !cancelled && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: 'none',
      border: "dashed 2px ".concat(_Colors.grayElementColor),
      color: _Colors.discreetTextColor,
      fontWeight: 'normal',
      fontSize: '1rem',
      lineHeight: '1.4',
      minHeight: '1em',
      verticalAlign: 'baseline',
      margin: '0 .25em 0 0',
      padding: '0.8em 1.5em 0.8em',
      textAlign: 'center'
    },
    fluid: true,
    primary: true
  }, t('Ticket not available yet')))));
};

var _default = TicketWidget;
exports["default"] = _default;